import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { push } from 'react-router-redux';
import { auth } from '../../../services';
import { getLoggedinUser } from '../../Actions/EndUser/AuthActions';


export const GET_MEMBERSHIPTYPES = 'GET_MEMBERSHIPTYPES';
export const SELECT_MEMBERSHIPTYPE = 'SELECT_MEMBERSHIPTYPE';
export const GET_MEMBERSHIPPACKAGES = 'GET_MEMBERSHIPPACKAGES';
export const SELECT_MEMBERSHIPPACKAGE = 'SELECT_MEMBERSHIPPACKAGE';
export const ADD_MEMBERSHIP = 'ADD_MEMBERSHIP';
export const ADD_ADDONS = 'ADD_ADDONS';
export const ADD_DONATIONS = 'ADD_DONATIONS';
export const ADD_INTEREST_FOR_MEMBERSHIP = 'ADD_INTEREST_FOR_MEMBERSHIP';
export const SIGNUP_USERINFO = 'SIGNUP_USERINFO';
export const SET_USER_ID = 'SET_USER_ID';
export const GET_ADDONS = 'GET_ADDONS';
export const GET_DONATIONS = 'GET_DONATIONS';

export const SELECT_PAYWITHCARD = 'SELECT_PAYWITHCARD';

export const UPDATE_PAYMENT_REQUEST = 'UPDATE_PAYMENT_REQUEST';
export const UPDATE_PAYMENT_SUCCESS = 'UPDATE_PAYMENT_SUCCESS';
export const UPDATE_PAYMENT_ERROR = 'UPDATE_PAYMENT_ERROR';

export const CLEAR_ALERTS = 'CLEAR_ALERTS';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchMembershipTypes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/Signup/GetMembershipTypes`)
            .then((response) => dispatch({
                type: GET_MEMBERSHIPTYPES,
                membershipTypes: response.data
            })).catch((response) => {
                console.log(response);
            })
    }
}
export function selectMembershipType(selectedMembershipTypeObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_MEMBERSHIPTYPE,
            selectedMembershipType: selectedMembershipTypeObject
        })
    }
}
export function fetchMembershipPackages(membershipTypeId) {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/Signup/GetMembershipPackages?membershipTypeId=${membershipTypeId}`)
            .then((response) => dispatch({
                type: GET_MEMBERSHIPPACKAGES,
                membershipPackages: response.data
            })).catch((response) => {
                console.log(response);
            })
    }
}
export function selectMembershipPackage(selectedMembershipPackageObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_MEMBERSHIPPACKAGE,
            selectedmembershipPackage: selectedMembershipPackageObject
        })
    }
}

export function addMembership(model) {
    return function (dispatch) {
        model.MailingStateId = model.StateObject.id;
        dispatch(loader(true));
        dispatch({
            type: ADD_MEMBERSHIP,
            inputMembershipInformation: model
        });
        dispatch(loader(false));
    };
}

export function addInterestForMembership(model) {
    return function (dispatch) {
        dispatch(loader(true));
        dispatch({
            type: ADD_INTEREST_FOR_MEMBERSHIP,
            interests: model
        });
        dispatch(loader(false));
    };
}

export function addAddons(model) {
    return function (dispatch) {
        dispatch(loader(true));
        model.AddtoCartList.map((addon) => {
            addon.cost = addon.price
        });

        dispatch({
            type: ADD_ADDONS,
            addons: model
        });
        dispatch(loader(false));
    };
}

export function addDonations(model) {
    return function (dispatch) {
        dispatch(loader(true));
        dispatch({
            type: ADD_DONATIONS,
            donations: model
        });
        dispatch(loader(false));
    };
}

export function selectPaywithCard(selectedPaywithcardObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_PAYWITHCARD,
            selectedPaywithCard: selectedPaywithcardObject
        })
    }
}

export function setUserId(userId) {
    return function (dispatch) {
        dispatch({
            type: SET_USER_ID,
            payload: userId
        })

        dispatch(push('/membership'))
    }
}

export function getAddons() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/Signup/GetAddons`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_ADDONS,
                    payload: response.data
                })
            })
            .catch((response) => {
                console.log(response);
            });
    }
}

export function getDonationTypes() {
    return function (dispatch) {
        axios.get(`${ROOT_API_URL}/ManageTransaction/GetDonationTypes`)
            .then((response) => {
                dispatch({
                    type: GET_DONATIONS,
                    payload: response.data
                })
            })
            .catch((response) => {
                console.log(response);
            });
    }
}

export const updatePayment = (details) => {
	return (dispatch) => {
		dispatch({
			type: UPDATE_PAYMENT_REQUEST,
			payload: details
        });

        var url = `${ROOT_API_URL}/users/PayDues`;
		const options = { method: 'POST', headers: auth.authHeader() };
        axios.post(url, details, options)
            .then((res) => {
                //debugger;

                if (res && res.data && res.data.isSuccess) {
				    dispatch({
					    type: UPDATE_PAYMENT_SUCCESS,
					    payload: res.data.message
				    });
			    } else {
				    dispatch({
					    type: UPDATE_PAYMENT_ERROR,
					    payload: res.data.message
				    });
			    }
            })
            .catch((res) => {
                console.log(res);
                dispatch({
                    type: UPDATE_PAYMENT_ERROR,
                    payload: res.message
                });
            });
        ;
	};
};

export const clearAlerts = () => {
    return function (dispatch) {
        dispatch({
            type: CLEAR_ALERTS,
        });
    }
};